import React, { useState, useRef } from "react";
import { Box, TextField } from "@mui/material";
import PropTypes from "prop-types";

export default function CodeInput({ onComplete }) {
  const [values, setValues] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);

  const handleChange = (value, idx) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newValues = [...values];
    newValues[idx] = value;
    setValues(newValues);

    if (value && idx < 5) {
      inputsRef.current[idx + 1]?.focus();
    }

    if (newValues.every((v) => v !== "")) {
      onComplete(newValues.join(""));
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !values[idx] && idx > 0) {
      inputsRef.current[idx - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("Text").slice(0, 6);
    const split = pasted.split("");
    const newValues = [...values];
    split.forEach((char, i) => {
      if (/^[0-9]$/.test(char)) {
        newValues[i] = char;
      }
    });
    setValues(newValues);
    if (newValues.every((v) => v !== "")) {
      onComplete(newValues.join(""));
    }
  };

  return (
    <Box display="flex" gap={2} mt={1} onPaste={handlePaste}>
      {values.map((val, idx) => (
        <TextField
          key={idx}
          inputRef={(el) => (inputsRef.current[idx] = el)}
          value={val}
          variant="outlined"
          inputProps={{ maxLength: 1, style: { textAlign: "center", fontSize: "1.5rem" } }}
          sx={{ width: 50 }}
          onChange={(e) => handleChange(e.target.value, idx)}
          onKeyDown={(e) => handleKeyDown(e, idx)}
        />
      ))}
    </Box>
  );
}

CodeInput.propTypes = {
  onComplete: PropTypes.func.isRequired,
};
